import styled from "styled-components";
import { ConfigInput } from "./inputs";

export const StyledLegend = styled.legend`
  width: auto;
  margin: auto;
  margin-left: 0;
  padding-inline-start: 2px;
  padding-inline-end: 2px;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  color: rgb(0, 0, 0);
  font-weight: 500;
  padding-bottom: 8px;
`;
export const StyledResultItemArea = styled.div`
  & > * {
    margin: 0.5rem;
  }
`;

export const StyledConfigInputFullWidth = styled(ConfigInput)`
  width: 100%;
`;
